import * as Styled from "./header.styles";

export function Header() {
  return (
    <Styled.Header>
      <Styled.HeaderInner>
        <Styled.H1>GovPass</Styled.H1>
      </Styled.HeaderInner>
    </Styled.Header>
  );
}
